import {
  Box,
  Button,
  Checkbox,
  Flex,
  Group,
  Stack,
  Table,
  Text,
  TextInput,
  Textarea,
  ThemeIcon,
  Tooltip,
} from '@mantine/core'
import { IconInfoCircleFilled } from '@tabler/icons-react'
import classes from './AdminSettings.module.css'

const MOCK_DATA = Array(5).fill({
  value: 'value',
  hidden: false,
  modifiedBy: 'Alfredo Carrillo',
  modifiedOn: (
    <Stack gap={0}>
      <Text size="xs">5:59pm</Text>
      <Text size="xs" c="dimmed">
        Mar 11
      </Text>
    </Stack>
  ),
})

export const CustomFieldsControlFieldDetails = () => {
  const rows = MOCK_DATA.map((item) => (
    <Table.Tr key={item.value}>
      <Table.Td style={{ whiteSpace: 'pre' }}>{item.value}</Table.Td>
      <Table.Td style={{ whiteSpace: 'pre' }}>
        <Checkbox />
      </Table.Td>
      <Table.Td>{item.modifiedBy}</Table.Td>
      <Table.Td>{item.modifiedOn}</Table.Td>
    </Table.Tr>
  ))

  return (
    <>
      <Flex p="md" gap={30} wrap="wrap">
        <Box w={450}>
          <Stack>
            <TextInput maw={450} size="md" label="Field label" withAsterisk />
            <TextInput
              maw={450}
              size="md"
              label="Description"
              description="This is an example of a field description."
            />
            <Textarea
              rows={5}
              label={
                <Group gap={3}>
                  <Text>Help text</Text>
                  <Tooltip label="Adds an info tag and displays this text on hoover.">
                    <ThemeIcon variant="transparent" color="dark">
                      <IconInfoCircleFilled size={18} />
                    </ThemeIcon>
                  </Tooltip>
                </Group>
              }
            />
          </Stack>
        </Box>
        <Box style={{ flex: '1 1 auto' }}>
          <TextInput
            maw={450}
            size="md"
            label="Field type"
            defaultValue="Picklist"
            disabled
          />
        </Box>
      </Flex>
      <Flex justify="flex-end" p="md">
        <Button variant="default">
          Add picklist value{' '}
          <Text c="red" span>
            *
          </Text>
        </Button>
      </Flex>
      <Table withRowBorders={false} verticalSpacing="xs">
        <Table.Thead>
          <Table.Tr className={classes.AdminSettings__thead}>
            <Table.Th key={`columns-1`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                Picklist values
              </Text>
            </Table.Th>

            <Table.Th key={`columns-2`} style={{ whiteSpace: 'pre' }}>
              <Group gap={0}>
                <Text size="xs" c="black">
                  Hidden
                </Text>
                <Tooltip label="Value is hidden as an option to select">
                  <ThemeIcon variant="transparent" color="black">
                    <IconInfoCircleFilled size={18} />
                  </ThemeIcon>
                </Tooltip>
              </Group>
            </Table.Th>

            <Table.Th key={`columns-1`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                Modified by
              </Text>
            </Table.Th>

            <Table.Th key={`columns-1`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                Modified on
              </Text>
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        {/* <Table.Tbody>{rows}
        </Table.Tbody> */}
      </Table>
      <Flex w="100%" justify="center" mt="xs">
        Enter at least 2 picklist values
      </Flex>

      <Flex p="md" mt="lg" justify="flex-start" gap="xs">
        <Button size="md" variant="default">
          Cancel
        </Button>
        <Button size="md">Next</Button>
      </Flex>
    </>
  )
}
